<template>
  <div>
    <v-dialog
      v-model="visibility"
      fullscreen
      hide-overlay
      dark
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card color="tertiary">
          <v-toolbar-title>Usage Manual</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="updateVisibility">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <template>
          <v-expansion-panel focusable>
            <v-expansion-panel-content
              v-for="(help, i) in helpTopics"
              :key="i">
              <div slot="header">{{ help.topic }}</div>
              <v-card>
                <v-card-text class="grey lighten-4" v-html="help.content">
                  {{ help.content }}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>

      </v-card>
    </v-dialog>
  </div>
 </template>

<script>
export default {
  name: 'help',
  props: {
    visibility: Boolean
  },
  data () {
    return {
      helpTopics: [
        {
          topic: 'Topic #1',
          content: '<p>Lorem ipsum dolor amet direct trade disrupt live-edge chillwave mlkshk church-key everyday carry tumblr hoodie. Poke jianbing normcore, sustainable prism scenester vegan stumptown hot chicken master cleanse hoodie. Cardigan hella humblebrag green juice, umami vexillologist fixie synth poke leggings authentic distillery. Salvia lumbersexual yuccie roof party, hashtag la croix banjo you probably haven\'t heard of them. Gochujang microdosing banh mi farm-to-table, keffiyeh locavore live-edge DIY bicycle rights bitters disrupt beard vexillologist before they sold out pickled. Tofu kale chips waistcoat, activated charcoal selfies stumptown yr pabst etsy.</p><p>Disrupt try-hard pok pok polaroid unicorn. Flexitarian 8-bit ennui enamel pin iPhone. Chicharrones biodiesel tumeric direct trade yuccie 90\'s chillwave kinfolk blog wolf gentrify. Put a bird on it hell of paleo snackwave small batch hexagon. Roof party chartreuse fixie locavore. Distillery brunch quinoa, woke meditation four loko everyday carry locavore etsy tbh taiyaki stumptown. Waistcoat tofu DIY, sriracha austin palo santo bicycle rights polaroid brunch cardigan freegan 8-bit pork belly man bun.</p>'
        },
        {
          topic: 'Second topic',
          content: '<p>Lorem ipsum dolor amet lumbersexual twee retro irony vegan skateboard af offal viral shaman plaid farm-to-table tacos street art. Banh mi lumbersexual cliche, plaid whatever waistcoat art party single-origin coffee ramps selfies poutine seitan shaman chambray messenger bag. Gluten-free bitters meggings ramps. Swag dreamcatcher plaid narwhal echo park enamel pin air plant brunch four loko tbh banjo. Vegan direct trade 90\'s hammock, selvage kombucha kitsch thundercats green juice la croix.</p><p>Organic butcher twee banjo, hashtag viral ugh. Chambray edison bulb 3 wolf moon, thundercats single-origin coffee keytar selvage four dollar toast etsy vegan cliche pour-over meditation bespoke pug. Vice waistcoat pork belly, unicorn kale chips vexillologist helvetica. Yuccie wolf sustainable glossier. Locavore succulents pork belly, lumbersexual chicharrones franzen four dollar toast brooklyn. Adaptogen vinyl cred, mumblecore air plant distillery locavore thundercats green juice normcore franzen pinterest authentic bespoke pork belly. Cloud bread williamsburg wolf, prism viral portland irony meh +1 shoreditch godard trust fund wayfarers.</p>'
        },
        {
          topic: '3rd topic',
          content: '<p>Lorem ipsum dolor amet plaid authentic meditation actually echo park. Biodiesel hella butcher cornhole, kombucha yr small batch coloring book crucifix knausgaard chambray stumptown you probably haven\'t heard of them single-origin coffee mumblecore. 3 wolf moon tilde literally, plaid fingerstache retro shabby chic disrupt mumblecore pork belly lyft slow-carb subway tile. Chicharrones keffiyeh everyday carry freegan la croix, bushwick jianbing lumbersexual iceland cred brunch kogi direct trade four dollar toast. Taiyaki asymmetrical 90\'s XOXO you probably haven\'t heard of them.</p><p>Tumeric hashtag actually, seitan blog mustache shoreditch letterpress ugh crucifix venmo. Truffaut woke authentic echo park raw denim you probably haven\'t heard of them drinking vinegar neutra fam everyday carry hashtag heirloom green juice. Mustache beard ethical squid. Gentrify godard seitan chartreuse kinfolk echo park butcher woke dreamcatcher church-key vinyl. Health goth single-origin coffee cloud bread, neutra letterpress leggings everyday carry gastropub.</p>'
        },
        {
          topic: 'Number 4',
          content: '<p>Lorem ipsum dolor amet snackwave etsy VHS, ugh live-edge pug post-ironic fashion axe kitsch humblebrag meh kickstarter tattooed farm-to-table cornhole. Hashtag cronut portland prism PBR&B selfies, +1 brunch slow-carb snackwave. Blog church-key biodiesel, banjo typewriter air plant kogi cronut semiotics hella flexitarian. Franzen chambray yuccie lo-fi health goth truffaut.</p><p>Typewriter before they sold out gastropub keffiyeh. Subway tile succulents disrupt tumblr gluten-free austin sartorial keffiyeh. Kitsch hammock whatever polaroid, iPhone swag bushwick slow-carb chambray. Hexagon brooklyn taiyaki, cloud bread mlkshk meditation activated charcoal photo booth. Cred cloud bread stumptown, intelligentsia wayfarers keffiyeh woke gochujang migas butcher retro pop-up four dollar toast. Fashion axe mustache tumblr, tofu tacos bitters tousled normcore coloring book truffaut offal fanny pack.</p>'
        }
      ]
    }
  },
  methods: {
    updateVisibility () {
      this.visibility = !this.visibility
      this.$root.$emit('helpVis')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HelpMenu.vue